<template>
  <div class="home-lawyer">
    <nav-header />
    <main class="home-lawyer-content">
      <div class="home-lawyer-consultation">
        <div class="home-lawyer-consultation-left">
          <div class="home-lawyer-consultation-left-online">在线充值</div>
          <div>
            <div class="home-lawyer-consultation-left-text">在线充值</div>
            <div class="home-lawyer-consultation-left-text">充值查询</div>
          </div>
          <div class="home-lawyer-consultation-left-online">充值帮助</div>
          <div>
            <div class="home-lawyer-consultation-left-text">温馨提示</div>
          </div>
        </div>
        <div class="home-lawyer-consultation-right">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名:" prop="userName">
              <el-input v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="密码:" prop="userPassword">
              <el-input v-model="ruleForm.userPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item label="账号:" prop="account">
              <el-input v-model="ruleForm.account"></el-input>
            </el-form-item>
            <el-form-item label="确认账号:" prop="confirmAccount">
              <el-input v-model="ruleForm.confirmAccount"></el-input>
            </el-form-item>
            <el-form-item label="充值金额:" prop="money">
              <el-radio-group v-model="ruleForm.money">
                <el-radio label="10元"></el-radio>
                <el-radio label="50元"></el-radio>
                <el-radio label="100元"></el-radio>
                <el-radio label="200元"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="充值方式" prop="recharge">
              <el-radio-group v-model="ruleForm.recharge">
                <el-radio label="网上银行"></el-radio>
                <el-radio label="支付宝"></el-radio>
                <el-radio label="财付通"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="ruleForm.recharge === '网上银行'">
              <el-radio-group v-model="ruleForm.bank" prop="bank" class="home-lawyer-consultation-right-bank">
                <el-radio label="1" style="margin-left: .3rem">
                  <img src="../../assets/bank/gongshang.gif"/>
                </el-radio>
                <el-radio label="2">
                  <img src="../../assets/bank/zhaohang.gif"/>
                </el-radio>
                <el-radio label="3">
                  <img src="../../assets/bank/nongye.gif"/>
                </el-radio>
                <el-radio label="4">
                  <img src="../../assets/bank/jianshe.gif"/>
                </el-radio>
                <el-radio label="5">
                  <img src="../../assets/bank/beijing.gif"/>
                </el-radio>
                <el-radio label="6">
                  <img src="../../assets/bank/jiaotong.gif"/>
                </el-radio>
                <el-radio label="7">
                  <img src="../../assets/bank/xingye.gif"/>
                </el-radio>
                <el-radio label="8">
                  <img src="../../assets/bank/nanjing.gif"/>
                </el-radio>
                <el-radio label="9">
                  <img src="../../assets/bank/minsheng.gif"/>
                </el-radio>
                <el-radio label="10">
                  <img src="../../assets/bank/guangda.gif"/>
                </el-radio>
                <el-radio label="11">
                  <img src="../../assets/bank/zhongguo.gif"/>
                </el-radio>
                <el-radio label="12">
                  <img src="../../assets/bank/pingan.gif"/>
                </el-radio>
                <el-radio label="13">
                  <img src="../../assets/bank/buohai.gif"/>
                </el-radio>
                <el-radio label="14">
                  <img src="../../assets/bank/dongya.gif"/>
                </el-radio>
                <el-radio label="15">
                  <img src="../../assets/bank/ningbo.gif"/>
                </el-radio>
                <el-radio label="16">
                  <img src="../../assets/bank/zhongxin.gif"/>
                </el-radio>
                <el-radio label="17">
                  <img src="../../assets/bank/shenfa.gif"/>
                </el-radio>
                <el-radio label="18">
                  <img src="../../assets/bank/guangfa.gif"/>
                </el-radio>
                <el-radio label="19">
                  <img src="../../assets/bank/shanghaibank.gif"/>
                </el-radio>
                <el-radio label="20">
                  <img src="../../assets/bank/shangpufa.gif"/>
                </el-radio>
                <el-radio label="21">
                  <img src="../../assets/bank/youzheng.gif"/>
                </el-radio>
                <el-radio label="22">
                  <img src="../../assets/bank/nongcunshangye.gif"/>
                </el-radio>
                <el-radio label="23">
                  <img src="../../assets/bank/zheshang.gif"/>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="ruleForm.recharge === '支付宝'">
              <el-radio-group v-model="ruleForm.bank" prop="bank" class="home-lawyer-consultation-right-bank">
                <el-radio label="1" style="margin-left: .3rem">
                  <img src="../../assets/bank/zhifubao.jpg"/>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="ruleForm.recharge === '财付通'">
              <el-radio-group v-model="ruleForm.bank" prop="bank" class="home-lawyer-consultation-right-bank">
                <el-radio label="1" style="margin-left: .3rem">
                  <img src="../../assets/bank/yeepay.jpg"/>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="submitForm">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'consultation',
    components: {
      NavHeader
    },
    data () {
      return {
        ruleForm: {
          userName: '',
          userPassword: '',
          account: '',
          confirmAccount: '',
          money: '10元',
          recharge: '网上银行',
          bank: ''
        },
        rules: {}
      }
    },
    methods: {
      submitForm () {
        this.$alert('请前往网上银行页面进行充值！', {
          confirmButtonText: '确定',
          callback: action => {
            console.log('请前往网上银行页面进行充值！')
          }
        })
      }
    }
  }
</script>
<style lang="stylus">
  .home-lawyer {
    &-content {
      margin-top .72rem
      background #f7f7f7
    }
    &-consultation {
      width: 9.6rem
      margin 0 auto
      display: flex
      border: .01rem solid #999
      &-left {
        background-color: #999
        padding: .2rem
        width: 2rem
        min-height: 4.2rem
        cursor: pointer
        &-online {
          border-top: .01rem solid #666
          border-bottom: .01rem solid #666
          padding: .05rem 0
          color: #0b5ba5
          font-size: .16rem
          font-weight: bold
          margin: .3rem 0
        }
        &-text {
          height: .25rem
          line-height: .25rem
          padding-left: .05rem
        }
        &-text:hover {
          color: #0b5ba5
        }
      }
      &-right {
        padding: .2rem
        flex: 1
        &-bank {
          .el-radio {
            margin-bottom: .1rem;
          }
          img {
            width: 1.2rem
            vertical-align: bottom
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/consultation/consultation.vue